import { Button, type buttonVariants } from '@components/ui/button'
import { type ConfirmDialogType, getConfirmDialog } from '@constants/confirm-dialogs'
import { useDialog } from '@hooks/useDialog'
import { cn } from '@utils/shad-utils'
import type { VariantProps } from 'class-variance-authority'
import { Loader2 } from 'lucide-react'
import type React from 'react'
import { forwardRef } from 'react'

export interface AppButtonProps
  extends React.ComponentProps<'button'>,
    VariantProps<typeof buttonVariants> {
  autoWidth?: boolean
  className?: string
  confirm?: ConfirmDialogType
  loading?: boolean
}

export const AppButton = forwardRef<HTMLButtonElement, AppButtonProps>(
  (
    { autoWidth = false, children, className, confirm, loading = false, onClick, ...props },
    ref,
  ) => {
    const { withConfirm } = useDialog()

    const handleClick =
      confirm && onClick ? withConfirm(getConfirmDialog(confirm), onClick as () => void) : onClick

    return (
      <Button
        ref={ref}
        className={cn(
          `${props.size !== 'nopadding' ? 'rounded-full' : ''} ${autoWidth ? 'w-full' : ''}`,
          className,
        )}
        onClick={handleClick}
        disabled={loading || props.disabled}
        {...props}
      >
        {loading && <Loader2 className="animate-spin" />}
        {children}
      </Button>
    )
  },
)

AppButton.displayName = 'AppButton'
